module.exports = __webpack_public_path__ + "static/media/pencil-edit-icon.d01ac077.svg";